
export enum StatisticsTab {
    Combined = 'combined',
    Successfull = 'successful',
    Unsuccessful = 'unsuccessful',
    Last = 'last',
}
